import * as React from "react";

import {
  AnalyticsConfigurationProvider,
  AnalyticsProvider,
  createAnalyticsContext,
  useAnalyticsOtpGtm,
} from "../../../Common";

import { useReactWishlistGuestInitialState } from "../react-wishlist-guest-initial-state-provider";

import { ReactWishlistGuestAnalyticsInterface } from "./analytics-interface";

export const [analyticsContext, useWishlistGuestAnalytics] =
  createAnalyticsContext<ReactWishlistGuestAnalyticsInterface>();

const WishlistGuestAnalyticsProvider_Implementations: React.FunctionComponent =
  (props) => {
    const analyticsOtpGtm =
      useAnalyticsOtpGtm<ReactWishlistGuestAnalyticsInterface>();

    const implementations = React.useMemo(
      () => [analyticsOtpGtm],
      [analyticsOtpGtm]
    );

    return (
      <AnalyticsProvider
        context={analyticsContext}
        implementations={implementations}
      >
        {props?.children || []}
      </AnalyticsProvider>
    );
  };

export const WishlistGuestAnalyticsProvider: React.FunctionComponent = (props) => {
  return (
    <AnalyticsConfigurationProvider
      useInitialState={useReactWishlistGuestInitialState}
    >
      <WishlistGuestAnalyticsProvider_Implementations>
        {props.children || []}
      </WishlistGuestAnalyticsProvider_Implementations>
    </AnalyticsConfigurationProvider>
  );
};
